import { Trans } from "react-i18next";import { ChevronRight } from "lucide-react";
import { LeaveStatusBadge } from "./LeaveStatusBadge";

export function EmployeeLeaveMobileList({ rows, onSelect }) {
  return (
    <ul className="divide-y divide-[var(--color-text-border)]/35 md:hidden">
      {rows.map((row) =>
      <li key={row.id}>
          <button
          type="button"
          onClick={() => onSelect(row)}
          className="flex w-full items-center gap-3 px-4 py-3.5 text-left hover:bg-[var(--color-workspace)]/20 transition-colors cursor-pointer">
          
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-foreground truncate">{row.type}</p>
              <div className="mt-1.5">
                <LeaveStatusBadge status={row.status} />
              </div>
            </div>
            <ChevronRight className="h-4 w-4 shrink-0 text-[var(--color-text-secondary)]" aria-hidden="true" />
            <span className="sr-only"><Trans i18nKey="formActions.viewLeaveDetails" /></span>
          </button>
        </li>
      )}
    </ul>);

}
